module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "92",
      "height": "39",
      "viewBox": "0 0 92 39"
    }
  }, [_c('g', {
    attrs: {
      "id": "Groupe_10",
      "data-name": "Groupe 10",
      "transform": "translate(-426 -780)"
    }
  }, [_c('rect', {
    attrs: {
      "id": "Rectangle_309",
      "data-name": "Rectangle 309",
      "width": "92",
      "height": "39",
      "rx": "6",
      "transform": "translate(426 780)",
      "fill": "#a8a8a8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "Icon_awesome-play",
      "data-name": "Icon awesome-play",
      "d": "M19.053,9.639,3.25.3A2.143,2.143,0,0,0,0,2.151v18.68a2.153,2.153,0,0,0,3.25,1.854l15.8-9.338a2.153,2.153,0,0,0,0-3.708Z",
      "transform": "translate(461.944 788.005)",
      "fill": "#f4f4f4"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-491e6e4e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/help/svg/IconeVideo.vue
// module id = 3158
// module chunks = 0